import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
// import InputLabel from "@material-ui/core/InputLabel";
import ReactSelect from "../../UI/ReactSelect";

export default function Filter(props) {
  const {
    onHide,
    show,
    filterInputsUpdate,
    filterInputsUpdateSelect,
    filterInputs,
    assets,
  } = props;

  const [assetsOption, setAssetsOption] = React.useState(null);
  function handleChangeAssets(value) {
    setAssetsOption(value);
    filterInputsUpdateSelect("assetId", value.value);
  }
  const assetsOptions = assets.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.name,
  }));

  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Requests filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="employeeFullName"
                  name="employeeFullName"
                  label="Employee full name"
                  placeholder="Employee full name "
                  className="w-100"
                  value={filterInputs.employeeFullName}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  id="assetId"
                  name="assetId"
                  suggestions={assetsOptions}
                  handleChangeSingle={handleChangeAssets}
                  single={assetsOption}
                  label="Choose asset"
                  placeholder="Choose asset"
                  inputId="assetId"
                  value={filterInputs.assetId}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="text"
                  name="text"
                  label="Text "
                  placeholder="Text "
                  className="w-100"
                  value={filterInputs.text}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            {/* <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <InputLabel htmlFor="expiredDate">Request date</InputLabel>

                <TextField
                  id="requestDate"
                  name="requestDate"
                  className="w-100"
                  type="datetime-local"
                  value={filterInputs.requestDate}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div> */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
